.overlapping {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr;

  > * {
    grid-row-start: 1;
    grid-column-start: 1;
  }
}
